import { render, staticRenderFns } from "./bulk-payment-view.vue?vue&type=template&id=5d8d5f98&scoped=true"
import script from "./bulk-payment-view.vue?vue&type=script&lang=js"
export * from "./bulk-payment-view.vue?vue&type=script&lang=js"
import style0 from "./bulk-payment-view.vue?vue&type=style&index=0&id=5d8d5f98&prod&scoped=true&lang=css"
import style1 from "./bulk-payment-view.vue?vue&type=style&index=1&id=5d8d5f98&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8d5f98",
  null
  
)

export default component.exports